import { getErrorMessage } from '../../../api/unwrapQuery';
import React, { useEffect, useState } from 'react';
import { Button, Input, FormField } from '@neshane/blueberry';
import QRCode from 'qrcode';
import Modal from '../../../common/components/Modal/Modal';
import { startTotpSetup, verifyTotpSetup } from '../api/securityApi';
import './MfaSetupWizard.css';

const MfaSetupWizard = ({ isOpen, onClose, onEnabled }) => {
    const [setup, setSetup] = useState(null);
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [qrDataUrl, setQrDataUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [starting, setStarting] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!isOpen) return;
        setSetup(null);
        setCode('');
        setName('');
        setQrDataUrl('');
        setError(null);

        const load = async () => {
            setStarting(true);
            try {
                const res = await startTotpSetup();
                setSetup(res);
                if (res.otpauthUrl) {
                    const url = await QRCode.toDataURL(res.otpauthUrl, {
                        width: 220,
                        margin: 1,
                        color: { dark: '#0f172a', light: '#ffffff' },
                    });
                    setQrDataUrl(url);
                }
            } catch (err) {
                setError(getErrorMessage(err, 'خطا در احراز هویت') || 'خطا در شروع تنظیم احراز هویت');
            } finally {
                setStarting(false);
            }
        };
        load();
    }, [isOpen]);

    const handleVerify = async () => {
        if (!code.trim()) return;
        setLoading(true);
        setError(null);
        try {
            await verifyTotpSetup(code.trim(), name.trim() || undefined);
            onEnabled();
        } catch (err) {
            setError(getErrorMessage(err, 'خطا در احراز هویت') || 'کد نامعتبر است؛ دوباره تلاش کنید');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="فعال‌سازی Google Authenticator"
            size="medium"
        >
            <div className="mfa-wizard">
                <p className="mfa-wizard__intro">
                    اپلیکیشن Google Authenticator را روی گوشی خود باز کنید و کد QR را اسکن کنید
                    (یا کلید را به صورت دستی وارد کنید).
                </p>

                {error && <div className="mfa-wizard__error">{error}</div>}

                <div className="mfa-wizard__qr">
                    {starting ? (
                        <div className="mfa-wizard__placeholder">در حال تولید کد QR…</div>
                    ) : qrDataUrl ? (
                        <img src={qrDataUrl} alt="کد QR تنظیم احراز هویت" width={220} height={220} />
                    ) : (
                        <div className="mfa-wizard__placeholder">کد QR در دسترس نیست</div>
                    )}
                </div>

                {setup?.secret && (
                    <div className="mfa-wizard__secret">
                        <span className="mfa-wizard__secret-label">کلید پشتیبان:</span>
                        <code className="mfa-wizard__secret-value">{setup.secret}</code>
                    </div>
                )}

                <FormField label="نام دستگاه (اختیاری)" htmlFor="mfa-device-name" infoTipContent="نام دستگاه (اختیاری) - مثلاً: گوشی سامسونگ">
                    <Input
                        id="mfa-device-name"
                        fit="parent"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        placeholder="مثلاً: گوشی سامسونگ" maxLength={100} />
                </FormField>

                <FormField label="کد شش رقمی تأیید *" htmlFor="mfa-verify-code" infoTipContent="کد شش رقمی تأیید - ••••••">
                    <Input
                        id="mfa-verify-code"
                        fit="parent"
                        value={code}
                        onChange={(e) => setCode(e.target.value.replace(/[^0-9]/g, ''))}
                        placeholder="••••••"
                        maxLength={6}
                    />
                </FormField>

                <div className="mfa-wizard__actions">
                    <Button
                        color="primary"
                        fit="parent"
                        isDisabled={loading || code.trim().length < 6}
                        onClick={handleVerify}
                        text={loading ? 'در حال بررسی…' : 'فعال‌سازی'}
                    />
                </div>
            </div>
        </Modal>
    );
};

export default MfaSetupWizard;